var Profile = {
    resetErrors: function() {
        $.each($('input'), function(key, value) {
            if ($(this).hasClass('border-red-800')) {
                $(this).removeClass('border-red-800').addClass('border-gray-700');
                $(this).parent().find('span').hide();
                $('#messageDiv').removeClass('bg-red-800').removeClass('bg-green-800').hide();
            }
        });
        $.each($('select'), function(key, value) {
            if ($(this).hasClass('border-red-800')) {
                $(this).removeClass('border-red-800').addClass('border-gray-700');
                $(this).parent().parent().find('span').hide();
                $('#messageDiv').removeClass('bg-red-800').removeClass('bg-green-800').hide();
            }
        });
    },
    editProfile: function() {
        this.resetErrors();
        this.editProfilePromise()
            .then((response) => {
                $('#messageDiv').addClass('bg-green-800').show();
                $('#message').html(response.data.message);
            })
            .catch((error) => {
                //console.log(error.response);
                let message = error.response.data.message;
                $('#message').text(message);
                $('#messageDiv').removeClass('bg-green-800').addClass('bg-red-800').show();

                $.each(error.response.data.errors, function(key, value) {
                    //console.log("key = " + key);
                    //console.log("value = " + value);
                    let messageText = '#' + key + "Error";
                    $(messageText).text(value).show();
                    if ($('#' + key).hasClass('border-gray-700')) {
                        $('#' + key).removeClass('border-gray-700').addClass('border-red-800');
                    }
                    
                });
            });
    },
    editProfilePromise: function() {
        return new Promise((resolve, reject) => {

            let formData = new FormData();
            let avatarFile = document.getElementById('avatar').files[0];

            if (document.getElementById('avatar').files.length > 0)
                formData.append("avatar", avatarFile, avatarFile.name);
            formData.append("uid", $('#uid').val());
            formData.append("password1", $('#password1').val());
            formData.append("password2", $('#password2').val());

            window.axios.post('/submit/profile', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error)
            });
        });
    }
}

$(document).ready(function() {
    // edit the profile
    $('#submitProfile').on('click', function(e) {
        Profile.editProfile();
    });
});